<template>
  <div class="navbody" >
    <el-divider content-position="left">知识点流程列表管理</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入流程名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.category_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="流程名称" prop="nav"><el-input v-model="categoryForm.nav" size="mini"></el-input></el-form-item>
          <el-form-item label="所属一级" prop="categoryId">
            <div style="display: flex; flex-direction: row">
              <div style="margin-right: 0.2rem; width: 100%">
                <el-cascader
                  clearable
                  filterable
                  v-model="categoryForm.categoryId"
                  :options="options"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'category_name',
                    value: 'id',
                    checkStrictly: true,
                  }"
                  @click.native="loadCategory"
                  size="mini"
                  style="width: 100%"
                  ref="cascader"
                ></el-cascader>
                <!-- @change="handleChangeCascader" -->
              </div>
            </div>
            <i
              class="el-icon-message-solid"
              style="color: #e6a23c; font-size: small"
              >不选分类就视为顶级分类！</i
            >
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="categoryForm.desc" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="流程名称" prop="categoryId">
            <el-input
              v-model="editCategoryForm.categoryId"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input v-model="editCategoryForm.desc" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="ifDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      ref="categoryData"
      max-height="650"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      row-key="id"
      @cell-dblclick="tabClick"
      :row-class-name="tableRowClassName"
      :cell-class-name="tableCellClassName"
      @expand-change="change"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
      @row-click="device_detail"
    >
      <!-- <el-table-column prop="id" label="ID"> </el-table-column> -->
      <el-table-column prop="category_name" label="流程名称"> </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSortC(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadioC(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="描述"
        show-overflow-tooltip
      >
      <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.desc"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.desc }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-popconfirm
                  cancel-button-text="取消"
                  confirm-button-text="确认"
                  icon="el-icon-question"
                  icon-color="red"
                  title="您确认删除当前及其全部下级吗"
                  @onConfirm="deleRow"
                >
                <el-button
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                >
                </el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'KnowledgeProcess',
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      callback()
    }
    return {

      clickRow: null,
      clickCell: null,
      tabClickLabel: null,
      getColumn: null,
      getColumnValue: null,
      editType: 0,
      needAddImg: [],
      pageSize_in: 16,
      nowPage_in: 1,
      total_in: 0,
      npage_in: 1,
      mover: [],
      checkedImages: [],
      navImages: [],
      headers: {
        Authorization: localStorage.getItem('token')
      },
      fileList: [],
      limit: 10,
      needUrl: [],
      imgListdialog: false,
      addAddressForm: {
        category_name: '',
        url: '',
        icon: '',
        display: false,
        alert: true,
        image: '',
        desc: ''
      },
      searchArr: {
        category_id: ''
      },
      loadC: [],
      npage: 1,
      needRow: '',
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ifAlert: false,
      ListIfDisplay: [],
      ListIfAlert: [],
      listSort: [],
      options: [],
      category: '',
      editId: '',
      categoryForm: {
        nav: '',
        categoryId: '',
        category_name: '',
        display: false,
        desc: ''
      },
      editCategoryForm: {
        nav: '',
        categoryId: '',
        category_name: '',
        display: false,
        desc: '',
        srcList: []
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        category_name: [
          { required: true, message: '流程名称', trigger: 'blur' },
          { max: 100, message: '分类名不超过100字符', trigger: 'blur' }
        ],
        desc: [{ max: 150, message: '描述不超过150字符', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'categoryForm.categoryId': {
      handler () {
        if (this.$refs.cascader) {
          this.$refs.cascader.dropDownVisible = false
        }
      }
    }
  },
  methods: {
    // 控制input显示 row 当前行 column 当前列
    tabClick (row, column, cell, event) {
      this.clickRow = row.index
      this.clickCell = column.index
      this.tabClickLabel = column.label
    },
    // 把每一行的索引放进row
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },

    // 把每一列的索引放进column
    tableCellClassName ({ column, columnIndex }) {
      column.index = columnIndex
    },

    // 失去焦点初始化
    inputBlur (row) {
      if (this.tabClickLabel === '描述') {
        this.getColumn = 'desc'
        this.getColumnValue = row.desc
      }
      this.$axios
        .get('api/knowledge_process/doubleedit', {
          params: {
            id: row.id,
            getColumn: this.getColumn,
            getColumnValue: this.getColumnValue
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.clickRow = null
            this.clickCell = null
            this.tabClickLabel = ''
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch()
    },
    loadTable () {
      this.$axios
        .get('api/knowledge_process/index', {
          params: {
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            console.log('====123====', this.categoryData)
            // this.total = data.data.total
            this.loadRadio()
            this.loadRadioAlert()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadRadioAlert () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        if (item.alert === 1) {
          this.ListIfAlert[item.id] = false
        } else {
          this.ListIfAlert[item.id] = true
        }
      })
    },
    loadSort () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    deleRow () {
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/knowledge_process/del', {
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.categoryData = data.data.data
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    editRow (index, data) {
      // this.needRow = index
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/knowledge_process/show', {
            // params: {
            //   id: data[index].id
            // }
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              if (data.data.display === 1) {
                this.ifDisplay = false
              } else {
                this.ifDisplay = true
              }
              data.data.alert === 1
                ? (this.ifAlert = false)
                : (this.ifAlert = true)
              this.editCategoryForm.categoryId = data.data.category_name
              this.editCategoryForm.url = data.data.url
              this.editCategoryForm.icon = data.data.icon
              this.editCategoryForm.desc = data.data.desc
              this.editCategoryForm.show = data.data.show
              this.editCategoryForm.srcList = data.data.img
              this.category = data.data.id
            }
          })
          .catch()
        this.categoryEditDrawer = true
      })
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/knowledge_process/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      this.npage = 1
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/knowledge_process/store', {
              category_name: this.categoryForm.nav,
              parents: this.categoryForm.categoryId,
              desc: this.categoryForm.desc,
              display: this.categoryForm.display === false ? 1 : 0
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.needAddImg = []
                this.categoryIndrawer = false
                this.resetForm('categoryForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      setTimeout(() => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$axios
              .put('api/knowledge_process/edit', {
                id: this.editId,
                category_name: this.editCategoryForm.categoryId,
                desc: this.editCategoryForm.desc,
                display: this.ifDisplay === false ? 1 : 0
              })
              .then(res => {
                const { data } = res
                if (data.code === 1) {
                  this.$message.success(data.msg)
                  this.categoryEditDrawer = false
                  this.categoryData = data.data.data
                  // this.loadTable()
                  // this.toggleRowExpansion_forAll(this.categoryData, false)
                } else {
                  this.$message.error(data.msg)
                }
              })
              .catch()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })
    },
    editListRadioC (row) {
      setTimeout(() => {
        this.$axios
          .put('api/knowledge_process/listshow', {
            id: this.editId,
            display: this.ListIfDisplay[row.id] === false ? 1 : 0
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    setSortC (row) {
      setTimeout(() => {
        if (isNaN(this.listSort[row.id])) {
          this.$message.error('排序值为数字！')
          return false
        }
        this.$axios
          .put('api/knowledge_process/setsort', {
            id: this.editId,
            sort: this.listSort[row.id]
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    clearSelf () {
      this.resetForm('addAddressForm')
    },
    loadCategory () {
      this.$axios
        .get('api/knowledge_process/get_cate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.options = data.data
            console.log('===123===', this.options)
          }
        })
        .catch()
    },
    device_detail (val) {
      // this.needRow = val
      this.editId = val.id
    },
    loadRadioC (c) {
      c.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadRadioAlertC (c) {
      c.map(item => {
        if (item.alert === 1) {
          this.ListIfAlert[item.id] = false
        } else {
          this.ListIfAlert[item.id] = true
        }
      })
    },
    loadSortC (c) {
      c.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    change (v1, v2) {
      if (v2) {
        this.loadC = v1.children
        var cChildren = v1.children
        this.loadRadioC(cChildren)
        this.loadRadioAlertC(cChildren)
        this.loadSortC(cChildren)
      } else {
        this.loadC = []
        this.cChildren = []
      }
    },
    loadAll (c) {
      this.loadRadioC(c)
      this.loadRadioAlertC(c)
    },
    // toggleRowExpansion_forAll (data, isExpansion) {
    //   data.forEach(item => {
    //     this.$refs.categoryData.toggleRowExpansion(item, isExpansion)
    //     if (item.children !== undefined && item.children !== null) {
    //       this.toggleRowExpansion_forAll(item.children, isExpansion)
    //     }
    //   })
    // },
    loadEdit () {
      setTimeout(() => {
        if (!this.editId) return false
        this.$axios
          .get('api/knowledge_process/show', {
            // params: {
            //   id: data[index].id
            // }
            params: {
              id: this.editId
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              if (data.data.display === 1) {
                this.ifDisplay = false
              } else {
                this.ifDisplay = true
              }
              data.data.alert === 1
                ? (this.ifAlert = false)
                : (this.ifAlert = true)
              this.editCategoryForm.categoryId = data.data.category_name
              this.editCategoryForm.url = data.data.url
              this.editCategoryForm.icon = data.data.icon
              this.editCategoryForm.desc = data.data.desc
              this.editCategoryForm.show = data.data.show
              this.editCategoryForm.srcList = data.data.img
              this.category = data.data.id
            }
          })
          .catch()
      })
    }
  },
  computed: {
    srcList () {
      if (this.editCategoryForm.srcList.length > 0) {
        var arr = this.editCategoryForm.srcList.map(item => {
          return item.url
        })
        return arr
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  }
}
</script>

<style  scoped>
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
.navbody {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/knowledge/knowledge_process.vue